<div mat-dialog-title style="color: #b71c1c; text-align: center;">
  GRADEBOOK ACCESS DENIED
</div>

<mat-dialog-content>
  <div *ngIf="!mergeStandardsConflict && !mergeAddTeacherConflict && !mergeOverrideDateConflict">
    <div *ngIf="course.GradebookAccess" style="color: #b71c1c; text-align: center;">
      Missing Default Grade Scale for Site-Year
    </div>
    <div *ngIf="!course.GradebookAccess">
      This gradebook is set up to use curriculum marks instead of numeric entries for standards.
      <br><br>
      In order to be used for standards, curriculum marks must have Score Values defined.
      Score Values need to be entered on the curriculum marks associalted with this course.
      <br><br>
      Curriculum marks are managed in District Settings.
    </div>
  </div>

  <!-- Restrict access if any Merge Conflicts exists -->
  <div style="padding-top:10px; padding-bottom:10px;">
    <div *ngIf="mergeStandardsConflict" style="color: #b71c1c; text-align: center;">
      Standards cannot be associated with Merged Sections.
    </div>
    <div *ngIf="mergeAddTeacherConflict" style="color: #b71c1c; text-align: center;">
      Merged Sections must have the same Additional Teachers assigned.
    </div>
    <div *ngIf="mergeOverrideDateConflict" style="color: #b71c1c; text-align: center;">
      Merged Sections must have the same Start/End Override Dates.
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="flex-footer-right">
    <tyl-button id="gradebookWarningsCloseButton" image="cancel.png" label="Close" (clickEvent)="closeClick()">
    </tyl-button>
  </div>
</mat-dialog-actions>